import axios from 'axios';
import { URL_DOCUMENTS_LIST } from './config';

export async function getDocumentsList() {
    const result = await axios.get(URL_DOCUMENTS_LIST);
    return result.data.data;
};

